import restArguments from './restArguments.js';
import unzip from './unzip.js';

// Zip together multiple lists into a single array -- elements that share
// an index go together.
export default restArguments(unzip);



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/zip.js
// module id = 1618
// module chunks = 106